import { render } from "./primaryModalComponent.vue?vue&type=template&id=5f758114&scoped=true"
import script from "./primaryModalComponent.vue?vue&type=script&lang=js"
export * from "./primaryModalComponent.vue?vue&type=script&lang=js"

import "./primaryModalComponent.vue?vue&type=style&index=0&id=5f758114&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f758114"]])

export default __exports__